
import React from 'react';
import VimeoPlayer from '@/components/vimeo/VimeoPlayer';

interface VideoPlayerProps {
  vimeoId: string;
  autoplay: boolean;
  startTime?: number;
  preload?: 'auto' | 'metadata' | 'none';
  lazyLoad?: boolean;
  className?: string;
  onIframeLoad?: () => void;
  previewDuration?: number; // Duration in seconds for preview loading
}

export const VideoPlayer: React.FC<VideoPlayerProps> = ({
  vimeoId,
  autoplay,
  startTime = 0,
  preload = 'metadata',
  lazyLoad = true,
  className,
  onIframeLoad,
  previewDuration = 30,
}) => {
  return (
    <VimeoPlayer 
      vimeoId={vimeoId} 
      autoplay={autoplay} 
      loop={true} 
      background={true} 
      muted={true} 
      controls={false} 
      startTime={startTime} 
      preload={preload}
      lazyLoad={lazyLoad}
      className={className}
      onIframeLoad={onIframeLoad}
      previewDuration={previewDuration}
    />
  );
};
